// extracted by mini-css-extract-plugin
module.exports = {"inView":"TableOfContents_inView__5jH6W"};